import React from 'react';

// Minimal 1.6px-stroke icon set shared by the nav dropdown, platform rows,
// and home sections. All inherit currentColor.

export const CheckIcon = () => (
  <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
    <circle cx="10" cy="10" r="9" fill="rgba(22, 163, 74, 0.12)" />
    <path d="M6 10.2L8.8 13L14 7.4" stroke="#16a34a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const ArrowIcon = () => (
  <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <path d="M3 8H13M13 8L8.5 3.5M13 8L8.5 12.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const ArrowUpRightIcon = () => (
  <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <path d="M4 12L12 4M12 4H5.5M12 4V10.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const DrawingsIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="1.6" />
    <path d="M3 9H21" stroke="currentColor" strokeWidth="1.4" />
    <path d="M9 3V21" stroke="currentColor" strokeWidth="1.4" />
    <path d="M15 14L17 16L13 20" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const RfiIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M4 5C4 3.9 4.9 3 6 3H18C19.1 3 20 3.9 20 5V21L16 18L12 21L8 18L4 21V5Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    <path d="M8 8H16" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
    <path d="M8 11H16" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
    <path d="M8 14H13" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
  </svg>
);

export const SubmittalsIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M5 4H15L19 8V20C19 20.55 18.55 21 18 21H5C4.45 21 4 20.55 4 20V5C4 4.45 4.45 4 5 4Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    <path d="M15 4V8H19" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    <path d="M8 13H15" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
    <path d="M8 16H13" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
  </svg>
);

export const DailyLogsIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <rect x="3" y="5" width="18" height="16" rx="2" stroke="currentColor" strokeWidth="1.6" />
    <path d="M3 9H21" stroke="currentColor" strokeWidth="1.4" />
    <path d="M8 3V7" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    <path d="M16 3V7" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    <path d="M7 13H11" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
    <path d="M7 17H15" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
  </svg>
);

export const PunchIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M5 4H17L21 8V20C21 20.55 20.55 21 20 21H5C4.45 21 4 20.55 4 20V5C4 4.45 4.45 4 5 4Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    <path d="M17 4V8H21" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    <path d="M8 13L11 16L17 10" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const LocationsIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M12 2.5C8 2.5 5 5.5 5 9.5C5 15 12 21.5 12 21.5C12 21.5 19 15 19 9.5C19 5.5 16 2.5 12 2.5Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    <circle cx="12" cy="9.5" r="2.5" stroke="currentColor" strokeWidth="1.6" />
  </svg>
);

export const TimeIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.6" />
    <path d="M12 7V12L15 14" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const AssetIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M12 3L21 7.5L12 12L3 7.5L12 3Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    <path d="M21 7.5V16.5L12 21L3 16.5V7.5" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    <path d="M12 12V21" stroke="currentColor" strokeWidth="1.4" />
  </svg>
);

export const ActionsIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M13 2L4 14H11L10 22L20 9H13L13 2Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
  </svg>
);

export const FormsIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <rect x="4" y="3" width="16" height="18" rx="2" stroke="currentColor" strokeWidth="1.6" />
    <path d="M8 8H16" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
    <path d="M8 12H16" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
    <path d="M8 16H12" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
  </svg>
);

export const GridIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <rect x="3" y="3" width="8" height="8" rx="1.5" stroke="currentColor" strokeWidth="1.6" />
    <rect x="13" y="3" width="8" height="8" rx="1.5" stroke="currentColor" strokeWidth="1.6" />
    <rect x="3" y="13" width="8" height="8" rx="1.5" stroke="currentColor" strokeWidth="1.6" />
    <rect x="13" y="13" width="8" height="8" rx="1.5" stroke="currentColor" strokeWidth="1.6" />
  </svg>
);

export const CaptureIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <rect x="3" y="6" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="1.6" />
    <path d="M8 6L9.5 3.5H14.5L16 6" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    <circle cx="12" cy="13" r="3.5" stroke="currentColor" strokeWidth="1.6" />
  </svg>
);

export const EyeIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M2.5 12C4.5 7.5 8 5 12 5C16 5 19.5 7.5 21.5 12C19.5 16.5 16 19 12 19C8 19 4.5 16.5 2.5 12Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.6" />
  </svg>
);

export const LoopIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M17 7H9C6.2 7 4 9.2 4 12C4 14.8 6.2 17 9 17H15" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
    <path d="M13 13L17 17L13 21" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M20 12C20 9.2 17.8 7 15 7" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" opacity="0.4" />
  </svg>
);

export const ShieldIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M12 2.5L20 5.5V11C20 16 16.5 20 12 21.5C7.5 20 4 16 4 11V5.5L12 2.5Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    <path d="M8.5 11.5L11 14L15.5 9.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const BadgeIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <circle cx="12" cy="9" r="5.5" stroke="currentColor" strokeWidth="1.6" />
    <path d="M8.5 13.5L7 21L12 18.5L17 21L15.5 13.5" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
  </svg>
);

export const KeyIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <circle cx="8" cy="14" r="4.5" stroke="currentColor" strokeWidth="1.6" />
    <path d="M11.5 10.5L19.5 2.5M19.5 2.5H15.5M19.5 2.5V6.5M16 6L18 8" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const TrafficIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M10.2 3.5H13.8L18 19H6L10.2 3.5Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    <path d="M8.7 9.5H15.3M7.5 14H16.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    <path d="M3.5 21H20.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

export const PlusIcon = () => (
  <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <path d="M8 3V13M3 8H13" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

export const ChevronIcon = () => (
  <svg viewBox="0 0 12 12" fill="none" aria-hidden="true">
    <path d="M2.5 4.5L6 8L9.5 4.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
